import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/mobile/fi-rr-angle-small-right.svg'


const _hoisted_1 = { class: "container-mobile bg-points-details overflow-auto" }
const _hoisted_2 = { class: "content content-points-details" }
const _hoisted_3 = { class: "header d-flex text-black p-3 custom-fs-18 container-390 position-fixed" }
const _hoisted_4 = { class: "mx-auto fw-medium" }
const _hoisted_5 = { class: "content-all-points px-3" }
const _hoisted_6 = {
  key: 0,
  class: "group-btns justify-content-between d-flex flex-wrap"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "total-withdrawn text-black"
}
const _hoisted_9 = { class: "total-yuan" }
const _hoisted_10 = {
  key: 2,
  class: "points-description mt-3"
}
const _hoisted_11 = { class: "filter-date-content d-flex justify-content-between align-items-center text-black" }
const _hoisted_12 = { class: "filter-name" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "filter d-flex flex-column position-absolute bg-white rounded-2"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "card-list-content mt-3 pb-3" }
const _hoisted_18 = { class: "block" }
const _hoisted_19 = { class: "type-card text-black e1 mb-1" }
const _hoisted_20 = { class: "date-card e2" }
const _hoisted_21 = { class: "block text-end" }
const _hoisted_22 = { class: "points-card text-black e1 mb-1" }
const _hoisted_23 = { class: "state-card e2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mask_layer = _resolveComponent("mask-layer")!
  const _component_Fade = _resolveComponent("Fade")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            role: "button",
            src: _imports_0,
            alt: "back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.BackToMyPoints()))
          }),
          _createElementVNode("div", _hoisted_4, _toDisplayString($setup.isCredited? $setup.local.points_details_5 : $setup.local.points_details_1), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!$setup.isCredited)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.valuesBtnArr, (item, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: _normalizeClass(["border-0 p-0 position-relative", [($setup.state.currentBtnVal === item) ? 'clicked btn' : 'btn']]),
                    key: index,
                    onClick: ($event: any) => ($setup.selectVal(item, index, 'type'))
                  }, _toDisplayString($setup.namesBtnArr[index]), 11, _hoisted_7))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          ($setup.isCredited)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createTextVNode(_toDisplayString($setup.userAvailablePurchasePointsNoRefundNoPending) + " ", 1),
                _createElementVNode("span", _hoisted_9, "≈ ￥ " + _toDisplayString($setup.userAvailablePurchasePointsNoRefundNoPendingYuan), 1)
              ]))
            : _createCommentVNode("", true),
          (!$setup.isCredited)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.local.points_details_2), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString($setup.local.points_details_3), 1),
            _createElementVNode("div", {
              role: "button",
              ref: "listRef",
              class: "filter-btn position-relative d-flex align-items-center justify-content-end",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleComponent('showFilter')))
            }, [
              _createElementVNode("span", null, _toDisplayString($setup.data.currentFilterVal), 1),
              _hoisted_13,
              _hoisted_14,
              ($setup.state.showFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.valuesFilterDate, (item, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        class: _normalizeClass(["p-2", [($setup.state.filterDateVal === item) ? 'clicked btn-item' : 'btn-item']]),
                        key: index,
                        onClick: ($event: any) => ($setup.selectVal(item, index, 'date'))
                      }, _toDisplayString($setup.namesFilterDate[index]), 11, _hoisted_16))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 512)
          ]),
          _withDirectives(_createElementVNode("div", { class: "empty-packages mt-3" }, _toDisplayString($setup.local.points_details_4), 513), [
            [_vShow, $setup.data.filteredCards.length == 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.filteredCards, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "item border-0 mb-3 d-flex justify-content-between p-3 bg-white rounded-2"
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(item.type), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString($setup.convertDate(item.created_at)), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString((+item.points >
                                0) ? `+${item.points}` : item.points), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(item.state), 1)
                ])
              ]))
            }), 128))
          ], 512), [
            [_vShow, $setup.data.filteredCards.length > 0]
          ])
        ])
      ]),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_mask_layer, null, null, 512), [
            [_vShow, $setup.state.showLoading]
          ])
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode(_component_Spinner, null, null, 512), [
      [_vShow, $setup.state.showLoading]
    ])
  ], 64))
}